import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityMigration } from "../../entity/EntityMigration";

export class DtoMigrationsGetRes extends EntityMigration {
  public items: EntityMigration[]  = [];
}
